import classesCss from './BasicFormLabel.module.css';

const BasicFormLabel = ({text, required=false, css="", sub=false}) => {
	return (
		<div className={`${classesCss.container} ${css}`}>
			<p className={classesCss.label} style={{
				fontSize: sub ? '30px' : '36px'
			}}>
				{text}
			</p>
			{
				required ? 
					<p className={classesCss.required}>* Required</p> : null
			}
		</div>
	);
};

export default BasicFormLabel;